import { createClient } from '@supabase/supabase-js'
import '../utils/supabaseConfig'

// These will need to be replaced with your actual Supabase project details
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Allow some time tolerance for token validation
    timeSkewTolerance: 60, // 60 seconds tolerance
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
})